import { ReactNode } from 'react';
import { Typography } from '@mui/material';
import { StyledCenterWrapper } from '@/components/CentredCustomText/CentredCustomText.styled';

interface ICentredCustomTextProps {
  text: string | ReactNode;
  className?: string;
}

export const CentredCustomText = ({ text, className }: ICentredCustomTextProps) => {
  return (
    <StyledCenterWrapper className={className}>
      <Typography color="customSecondary.neutral.100" align="center">
        {text}
      </Typography>
    </StyledCenterWrapper>
  );
};
